import { SimpleMemoryCache } from '../../common/caches/simple-memory-cache';
import { FEATURE_LAYERS_PROPERTIES } from '../constants';

type EntityIdToObjectIdMapsKey = keyof typeof FEATURE_LAYERS_PROPERTIES;
export const EntityIdToObjectIdMaps = Object.entries(FEATURE_LAYERS_PROPERTIES).reduce<
    Record<EntityIdToObjectIdMapsKey, SimpleMemoryCache<number>>
>(
    (acc, cur) => {
        acc[cur[0] as EntityIdToObjectIdMapsKey] = new SimpleMemoryCache<number>(cur[1].layerKey);
        return acc;
    },
    {} as Record<EntityIdToObjectIdMapsKey, SimpleMemoryCache<number>>
);

export const clearEntityCache = (cacheKey: EntityIdToObjectIdMapsKey) => {
    EntityIdToObjectIdMaps[cacheKey].reset();
};

// window.EntityIdToObjectIdMaps = EntityIdToObjectIdMaps;
